export enum DashboardViewsEnum {
  Dashboard = 'Dashboard',
  Create = 'Create new customer',
}
